<expandable-min-max-filter [config]="filterConfig()" />
